export const WHATSAPP_URL =
  "https://wa.me/5521996104480?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20a%20assessoria";

export const HERO_IMAGE = "/hero-illustration.png";

export const PASSPORT_IMAGE =
  "https://images.unsplash.com/photo-1581553673739-c4906b5d0de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwYXNzcG9ydCUyMGRvY3VtZW50JTIwY2xvc2V1cHxlbnwwfHx8fDE3ODc5MzkxMDZ8MA&ixlib=rb-4.1.0&q=85";
